import {ReactElement} from 'react';

import {Box, SxProps} from '@mui/material';

interface Props {
  children: ReactElement | ReactElement[];
  bgColor: string;
  sx?: SxProps;
  selfRef?: (node: HTMLDivElement | null) => void;
  topPosition?: number;
}

export const PdfPageSection = ({children, bgColor, sx, selfRef, topPosition}: Props) => {
  return (
    <Box
      ref={selfRef}
      sx={{
        backgroundColor: bgColor,
        width: '100%',
        position: 'absolute',
        left: 0,
        ...(topPosition && {top: topPosition}),
        clear: 'both',
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};
